import { render, staticRenderFns } from "./FallbackPictureCopyrightEditView.vue?vue&type=template&id=68526f2f"
import script from "./FallbackPictureCopyrightEditView.js?vue&type=script&lang=js&external"
export * from "./FallbackPictureCopyrightEditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports